module.exports = __webpack_public_path__ + "static/media/Graphics_2.7b578c43.png";